import { atom } from 'recoil';
import { Esim, EsimRequest } from '@/mobile/types/api/mypage/esim';

// eSIM 画面は発行可否とダウンロード可否を即参照するため、表示フラグを明示的に false で初期化する。
export const esimState = atom<Esim>({
  key: 'esimState',
  default: {
    can_display_issue: false,
    can_display_profile_download: false,
    esim_operation_type: '',
    esim_iccid: '',
  },
});

// 送信用パラメータを別 state に切り出し、取得済み契約情報とユーザー操作結果を混在させない。
export const esimRequestState = atom<EsimRequest>({
  key: 'esimRequestState',
  default: {
    operation_type: '',
    esim_iccid: '',
  },
});
